var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F2EBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 25.5H26C23.7908 25.5 22 27.2908 22 29.5C22 31.7092 23.7908 33.5 26 33.5H34C36.2092 33.5 38 31.7092 38 29.5C38 28.4856 37.6223 27.5593 37 26.8542",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28.1458C18.3776 27.4407 18 26.5144 18 25.5C18 23.2908 19.7909 21.5 22 21.5H30C32.2092 21.5 34 23.2908 34 25.5C34 27.7092 32.2092 29.5 30 29.5H25",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.29e75b7c.svg";
export { ForwardRef as ReactComponent };